import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 23 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 24\" id=\"download\"><path d=\"M14.232 2.404A6.59 6.59 0 008.56 5.626c.916.438 1.893 1.212 2.818 2.54l-.775.552c-1.42-2.04-2.64-2.475-3.96-2.475-2.617 0-4.745 2.152-4.745 4.797 0 2.646 2.128 4.799 4.744 4.799h2.846v-3.837h3.795v3.836h.95c3.66 0 6.64-3.013 6.64-6.717 0-3.703-2.98-6.717-6.64-6.717z\" /><path d=\"M14.51 17.08l-2.175 2.2v-6.318h-1.898v6.317l-2.175-2.2-1.342 1.357 4.466 4.517 4.466-4.517-1.342-1.357z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol